import * as React from 'react';
import { useLocation } from '@grandvisionhq/frk-routing';
import { ProductCatalogBreadcrumbs } from '@grandvisionhq/products';
import { useIntl } from '@grandvisionhq/state';
import '@swc/helpers';
import { useBrPageContext } from '../../../context/context.js';
import '@bloomreach/react-sdk';
import '../../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/utils';
import '@grandvisionhq/common';
import '../../../utils/http-client.js';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../../operations/mutations/signup-promotion.js';
import '../../../operations/mutations/subscribe-newsletter.js';
import '../../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { useBloomreachPageRoutes } from '../../../hooks/use-bloomreach-page-routes.js';
import { useBloomreachProductRoutes } from '../../../hooks/use-bloomreach-product-routes.js';
import '../../../hooks/use-breakpoint-visibility.js';
import { createProductTypeBreadcrumb, getProductTypeName } from './utils.js';

const CmsProductCatalogBreadcrumbs = ({ title  })=>{
    const [, pageRoutes] = useBloomreachProductRoutes();
    const { routes  } = useBloomreachPageRoutes();
    const { pathname  } = useLocation();
    const page = useBrPageContext();
    const { getLabel  } = useIntl();
    const createUrl = (url)=>{
        return url && (page === null || page === void 0 ? void 0 : page.isPreview()) ? page.getUrl(url) : url;
    };
    // Remove parameters from the path
    const sanitizedPath = pathname === null || pathname === void 0 ? void 0 : pathname.split('?')[0];
    // Create the root route
    const rootBreadcrumb = {
        name: getLabel('account.menu.home', {
            defaultValue: 'Home'
        }),
        url: createUrl(routes.root)
    };
    const breadcrumbs = [
        rootBreadcrumb
    ];
    // Retrieve the product type breadcrumb
    const productTypeBreadcrumb = createProductTypeBreadcrumb(pageRoutes, sanitizedPath, createUrl);
    if (productTypeBreadcrumb.name) {
        // Get the localized productType name
        productTypeBreadcrumb.name = getProductTypeName(productTypeBreadcrumb, getLabel, page);
        breadcrumbs.push(productTypeBreadcrumb);
    }
    // If the path is not equal to the path of the productType breadcrumb,
    // we are not on a standard productType page and will use the title as the last breadcrumb
    if (productTypeBreadcrumb.url !== sanitizedPath) {
        breadcrumbs.push({
            name: title
        });
    }
    return /*#__PURE__*/ React.createElement(ProductCatalogBreadcrumbs, {
        breadcrumbs: breadcrumbs
    });
};

export { CmsProductCatalogBreadcrumbs, CmsProductCatalogBreadcrumbs as default };
//# sourceMappingURL=ProductCatalogBreadcrumbs.js.map
